import {
	Component,
	OnInit,
	ViewChild,
	HostListener,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	signal,
} from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Modal } from 'bootstrap';
import { filter, Observable } from 'rxjs';

import { AuthService } from '../auth/auth.service';
import { Data2Service } from '../common/data2.service';
import { DateService } from '../common/date.service';
import { DataBagService } from '../common/data-bag.service';
import { UuidService } from '../common/uuid.service';
import { InfoboxService } from '../common/infobox/infobox.service';
import { TaskService } from '../common/php-task.service';
import { QuestionService } from '../common/question-dialog/question-dialog.service';
import { LoaderService } from '../common/loader/loader.service';
import {
	AccomodationKinds,
	CategoryEvent,
	EventVehicle,
	RentCategory,
	TermTourismEvent,
	TourismEvent,
} from './tourism-events.model';
import { TourismEventsLinkComponent } from './tourism-events-link/tourism-events-link.component';
import { TourismEventsSeasonComponent } from './tourism-events-season/tourism-events-season.component';
import { DriversEventAddComponent } from '../drivers/drivers-event-add/drivers-event-add.component';
import { PhpTaskComponent } from '../php-tasks/php-task/php-task.component';
import { TourismEventsService } from './tourism-events.service';
import { MatDialog } from '@angular/material/dialog';
import { OrganizationService } from '../organization/organization/organization.service';
import { TourismVehicleOutput } from '@/tourism-events/tourism-events-full/tourism-events-vehicle-add/tourism-events-vehicle-add.component';
import { Permissions } from '@/common/enums/Permissions';
import { TourismEventsCopyConfirmDialogComponent } from './tourism-events-copy-confirm-dialog/tourism-events-copy-confirm-dialog.component';

@Component({
	selector: 'app-tourism-events-common',
	template: '',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourismEventsComponent implements OnInit {
	@ViewChild(TourismEventsLinkComponent)
	linkComponent: TourismEventsLinkComponent;
	@ViewChild(TourismEventsSeasonComponent)
	seasonComponent: TourismEventsSeasonComponent;
	@ViewChild(DriversEventAddComponent)
	DriversEventAddComponent: DriversEventAddComponent;
	@ViewChild(PhpTaskComponent)
	TaskComponent: PhpTaskComponent;
	protected apiUrl = 'drivers';
	protected driverSalaryConfirmed = false;
	driverSelected;
	pageTitle: string;
	private itemsBeforeDataLoad = 7;
	editable: boolean;
	lockEdit = false;
	documentDriverCorrect = true;
	private readonly lockTime = 15; // minutes
	private lockTimer;
	private lockTimerSeconds: number;
	lockTimerText = '';
	drivers = [];
	driversById = {};
	touristGuides = [];
	categories = [];
	statuses = [];
	vehicles = [];
	driverDocuments = [];
	users = [];
	protected virtualDrivers = [];
	driverEventKind: Array<string> = ['drivers_departure', 'drivers_program', 'drivers_return'];
	board: [];
	accomodationKinds: Array<AccomodationKinds> = [
		{ id: '1', name: 'noclegi załogi = noclegi grupy' },
		{ id: '2', name: 'nocleg grupy inny niż załogi' },
		{ id: '3', name: 'bez noclegu (Express)' },
		{ id: '4', name: 'po stronie OSKARa' },
	];
	reportErrorComment = '';
	reportErrorField = '';
	reportErrorFieldName = '';
	focusedDriver: object = null;
	event: TourismEvent = {
		id: null,
		newId: null,
		created: null,
		status: null,
		type: null,
		drivers_departure: [],
		drivers_program: [],
		drivers_return: [],
		drivers_senior: [],
		tasks: [],
		sumValue: null,
		date_from: null,
		date_to: null,
		date_prepare: null,
		datePrepareAuto: true,
		program_date_from: null,
		program_date_to: null,
		planned_people_count: null,
		owner: null,
		organizationOwner: null,
		countries: null,
		name: null,
		category: null,
		crew_count: null,
		accommodation: null,
		text_departure: null,
		text_return: null,
		text_program: null,
		text_drivers: null,
		program_start_driver_place: null,
		program_end_driver_place: null,
		text_organization: null,
		text_client: null,
		text_refueling: null,
		text_billing: null,
		text_notes: null,
		tourist_guides_departure: null,
		tourist_guides_program: null,
		tourist_guides_return: null,
		briefingPlace: null,
		textBriefing: null,
		briefingUser: null,
		startPlace: null,
		startPlaceCity: null,
		startDate: null,
		endDate: null,
		endPlace: null,
		endPlaceCity: null,
		startPostCode: null,
		endPostCode: null,
		accommodation_detail: null,
		people: 0,
		drivers: null,
		text_hotel: null,
		city_source: null,
		city_destination: null,
		driver_informed_departure: false,
		driver_informed_return: false,
		departure_place_confirmed: false,
		return_place_confirmed: false,
		services_confirmed: false,
		board: null,
		detail_about_first_day_confirmed: false,
		detail_about_program_confirmed: false,
		detail_about_last_day_confirmed: false,
		services: false,
		board_confirmed: false,
		night_confirmed: false,
		night: null,
		is_virtual_driver: 1,
		text_opinion: null,
		date_deadline: null,
		dateDeadlineAuto: true,
		people_confirmed: false,
		client_wishes: null,
		client_representative: null,
		guide_informed: false,
		ready_for_printing: false,
		was_printed: false,
		client_informed: false,
		text_guide: null,
		place_return: null,
		agreement_signature: null,
		agreement_value: 0,
		agreement_value_currency: 'PLN',
		agreement_value_pln: null,
		predicted_profit: 0,
		predicted_profit_currency: 'PLN',
		predicted_profit_pln: null,
		agreement_mileage_limit: 0,
		invoiceRequired: true,
		invoiceRequiredNote: null,
		calculation_link: null,
		errorsCount: null,
		leadSource: null,
		note: null,
		client: null,
		clientEvent: null,
		vehicles: [],
	} as TourismEvent;
	boardTypes = ['BZ', 'BB', 'HB'];
	errors = {};
	incorrectDrivers = [];
	editor = ClassicEditor;
	editorConfig = {
		toolbar: ['bold', 'italic', '|', 'bulletedList', 'numberedList'],
	};

	selectedCategory = signal<CategoryEvent>(null);

	constructor(
		private readonly api: Data2Service,
		private readonly bag: DataBagService,
		private readonly date: DateService,
		private readonly infobox: InfoboxService,
		private readonly question: QuestionService,
		private readonly uuid: UuidService,
		private readonly task: TaskService,
		private readonly loader: LoaderService,
		private readonly router: Router,
		protected route: ActivatedRoute,
		public auth: AuthService,
		public dialog: MatDialog,
		public _serviceEvent: TourismEventsService,
		public _serviceOrganizaion: OrganizationService,
		private readonly cdr: ChangeDetectorRef,
	) {}

	@HostListener('window:beforeunload') canDeactivate(): Observable<boolean> | boolean {
		return this.lockEdit;
	}

	ngOnInit(): void {
		this.loader.show();
		if (this.route.snapshot.params['id']) {
			// We are in edit mode
			this.editable = true;
			this.lockEdit = true;
			this.event.id = this.route.snapshot.params['id'];
		} else {
			// We are in add mode
			this.editable = false;
			this.pageTitle = 'Dodawanie wydarzenia transportowego';
			this.defaultValues();
			this.calculateDatePrepare();
			this.calculateDateDeadline();
			this.event.owner = [this.auth.getUserId()];
		}
		this.api.get('/drivers/', (result, error) => {
			this.drivers = this.api.sortAlphabetically(result.data, 'last_name');
			this.drivers.forEach((driver) => {
				this.driversById[driver.id] = driver;
			});
			this.loadData();
		});
		this.api.get('/touristGuides/', (result, error) => {
			this.touristGuides = result.data;
			this.loadData();
		});
		this.api.get('/vehicles/', (result, error) => {
			this.vehicles = result.data;
			this.loadData();
		});
		this.api.get('/users/', (result, error) => {
			this.users = result.data;
			this.cdr.detectChanges();
			this.loadData();
		});
		this.api.get('/driverDocuments/', (result, error) => {
			this.driverDocuments = result.data;
			this.loadData();
		});
		this.api.get('/parameters/', (result, error) => {
			this.categories = this.typeParametersConvert(result, 6);
			this.statuses = this.typeParametersConvert(result, 7);
			this.loadData();
		});
		this.bag.get('/board/', (result, error) => {
			if (result) {
				const { results } = result;
				this.board = results
					.filter((v) => this.boardTypes.includes(v.code))
					?.map((obj) => ({
						...obj,
						id: obj.id.toString(),
					}));
			}
			this.loadData();
		});
	}

	setVehicles(vehicles: TourismVehicleOutput[]): void {
		this.event.vehicles = vehicles as unknown as EventVehicle[];
	}

	protected calculateStartDate() {
		this.event.startDate = this.event.date_from;
		this.event.endDate = this.event.date_to;
	}

	protected calculateEndDate() {
		this.event.endDate = this.event.date_to;
	}

	protected defaultValues() {}

	private loadData() {
		this.loader.show();
		if (!this.editable) {
			this.loader.hide();
			return;
		}
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.api.get('/tourismEvents/' + this.event.id + '/', (result, error) => {
			this.driverEventKind.forEach((type) => {
				result.data[type]?.forEach((driver) => {
					driver.dateFromAuto = driver.dateFromAuto == '1';
					driver.dateToAuto = driver.dateToAuto == '1';
					driver.confirmed = driver.confirmed == '1';
				});
			});
			result.data.datePrepareAuto = result.data.datePrepareAuto == '1';
			result.data.driver_informed_departure = result.data.driver_informed_departure == '1';
			result.data.driver_informed_return = result.data.driver_informed_return == '1';
			result.data.people_confirmed = result.data.people_confirmed == '1';
			result.data.guide_informed = result.data.guide_informed == '1';
			result.data.guide_informed_return = result.data.guide_informed_return == '1';
			result.data.dateDeadlineAuto = result.data.dateDeadlineAuto === '1';
			result.data.invoiceRequired = result.data.invoiceRequired == '1';
			result.data.detail_about_first_day_confirmed = result.data.detail_about_first_day_confirmed == '1';
			result.data.detail_about_last_day_confirmed = result.data.detail_about_last_day_confirmed == '1';
			result.data.detail_about_program_confirmed = result.data.detail_about_program_confirmed == '1';
			result.data.departure_place_confirmed = result.data.departure_place_confirmed == '1';
			result.data.return_place_confirmed = result.data.return_place_confirmed == '1';
			result.data.services_confirmed = result.data.services_confirmed == '1';
			result.data.board_confirmed = result.data.board_confirmed == '1';
			result.data.night_confirmed = result.data.night_confirmed == '1';
			result.data.reconciliation_type = isNaN(parseInt(result.data.reconciliation_type))
				? '0'
				: result.data.reconciliation_type;
			this.getOrganization(result.data?.clientEvent);
			this.event = result.data;
			this.event.agreement_value_currency = this.event.agreement_value_currency || 'PLN';
			this.event.predicted_profit_currency = this.event.predicted_profit_currency || 'PLN';
			this.selectedCategory.set(result.data.category);
			this.loader.hide();
			this.saveDrivers();
			this.pageTitle = 'Edycja: ' + this.event.name;
			this.calculateDatePrepare();
			this.calculateDateDeadline();
			this.checkDriverDocument();
		});
	}

	private getOrganization(obj) {
		if (!obj) return;
		obj.isOrganization = obj.isOrganization === '1';
		if (obj.isOrganization) {
			return this.bag.get(`/organization/${obj.client}/`, (result, error) => {
				this.event.client = result;
			});
		}
		if (!obj.isOrganization) {
			return this.bag.get(`/profile/data_full/${obj.client}/`, (result, error) => {
				this.event.client = result;
			});
		}
	}

	private saveDrivers() {
		this.driverEventKind.forEach((kind) => this.event[kind]?.forEach((eventDriver) => eventDriver.driver));
	}

	private checkDuplicateDriversExists(kind: string): boolean {
		const drivers = this.event[kind].map((v) => v.driver);
		const withoutDuplicates = new Set(drivers);
		return withoutDuplicates.size === 1 && drivers.length !== 1;
	}

	private typeParametersConvert(result, parameterId) {
		const newParms = [];
		const parameters = result.data.filter((obj) => obj.type_parameters_id == parameterId);
		parameters.forEach((obj) => {
			newParms.push({
				id: obj.code,
				name: obj.polish,
			});
		});
		return this.api.sortAlphabetically(newParms);
	}

	addDriversAuto() {
		if (
			this.event.drivers_departure.length ||
			this.event.drivers_program.length ||
			this.event.drivers_return.length ||
			!this.event.vehicles.length
		) {
			return;
		}
		const vehicle = this.findVehicleById(this.event.vehicles[0]?.id);
		switch (vehicle.type.id) {
			case 'autokar':
				this.event.drivers_departure.push(
					{
						driver: 'l3gNTlAlFRtaxC4rKlYRP5SSpE22zvKL',
						date_from: this.event.date_from,
						date_to: this.event.date_to,
						dateFromAuto: true,
						dateToAuto: true,
					},
					{
						driver: 'nRtlZk44k2LRBnXWn0bAyDKKxa2ZyAGS',
						date_from: this.event.date_from,
						date_to: this.event.date_to,
						dateFromAuto: true,
						dateToAuto: true,
					},
				);
				this.event.drivers_program.push(
					{
						driver: 'wfJPVSKaqiYRGHxS0RFCBrhVnxHqCC9a',
						date_from: this.event.date_from,
						date_to: this.event.date_to,
						dateFromAuto: true,
						dateToAuto: true,
					},
					{
						driver: 'yRA2UIBRyEVhvt42wUF5YnOiUcU1pT5t',
						date_from: this.event.date_from,
						date_to: this.event.date_to,
						dateFromAuto: true,
						dateToAuto: true,
					},
				);
				this.event.drivers_return.push(
					{
						driver: 'tTR7ySznYYmESzaV4TnAHpV8fiMpPdWC',
						date_from: this.event.date_from,
						date_to: this.event.date_to,
						dateFromAuto: true,
						dateToAuto: true,
					},
					{
						driver: 'ioXbFDV0iRzyxFvmnygRRqRNguxOYRF3',
						date_from: this.event.date_from,
						date_to: this.event.date_to,
						dateFromAuto: true,
						dateToAuto: true,
					},
				);
				break;
			case 'bus':
				this.event.drivers_program.push({
					driver: 'wfJPVSKaqiYRGHxS0RFCBrhVnxHqCC9a',
					date_from: this.event.date_from,
					date_to: this.event.date_to,
					dateFromAuto: true,
					dateToAuto: true,
				});
				break;
		}
	}

	editUnlock() {
		this.loader.show();
		this.api.get('/locks/tourismEvents/' + this.event.id + '/' + this.lockTime + '/', (result, error) => {
			this.loader.hide();
			if (error) {
				return;
			}
			this.lockEdit = false;
			this.lockTimerSeconds = this.lockTime * 60; // minutes
			this.lockTimerText = this.lockTime + ':00';
			if (this.lockTimer) {
				clearInterval(this.lockTimer);
			}
			this.lockTimer = setInterval(() => {
				this.lockTimerSeconds--;
				if (this.lockTimerSeconds < 0) {
					this.loader.show();
					window.location.reload();
					return;
				}
				const minutes = Math.floor(this.lockTimerSeconds / 60);
				const seconds = this.lockTimerSeconds - minutes * 60;
				const minutesText = minutes < 10 ? '0' + minutes.toString() : minutes.toString();
				const secondsText = seconds < 10 ? '0' + seconds.toString() : seconds.toString();
				this.lockTimerText = minutesText + ':' + secondsText;
			}, 1000);
		});
	}

	deleteAsk() {
		const element = document.getElementById('askModalDelete');
		element.style.display = 'block';
		element.style.paddingRight = '17px';
		element.className = 'modal fade show';
	}

	deleteConfirm() {
		this.deleteClose();
		this.loader.show();
		this.api.del('/tourismEvents/' + this.event.id + '/', (result, error) => {
			this.afterSend(result, error);
		});
	}

	checkDriverEventValid(): boolean {
		return this.driverEventKind.some((kind) => this.checkDuplicateDriversExists(kind));
	}

	deleteClose() {
		const element = document.getElementById('askModalDelete');
		element.style.display = 'none';
		element.className = 'modal fade';
	}

	submit(mode: 'save' | 'copy' = 'save') {
		if (this.checkDriverEventValid()) {
			return this.infobox.error(
				'Prawdopodobnie wpisano dwóch takich samych kierowców sprawdź, czy na wyjazd, program lub powrót nie są wpisani tacy sami kierowcy',
			);
		}
		if (this.driverSalaryConfirmed) {
			return this.infobox.error('Nie moża zapisać, poniweważ przypisany kierowca został już rozliczony');
		}
		if (this.event.date_to?.replace('T', ' ') < this.event.date_from?.replace('T', ' ')) {
			return this.infobox.error('Data rozpoczęcia wydarzenia nie może być większa od daty zakończenia');
		}
		if (!this.documentDriverCorrect) {
			return this.askQuestion(
				'Do wydarzenia są przypisani kierowcy, których termin dokumentu niedługo wygaśnie lub jest po terminie! Czy mimo to chcesz zapisać?',
			);
		}
		this.loader.show();
		let hasErrors = false;
		for (const key in this.errors) {
			if (!this.event[key] || (Array.isArray(this.event[key]) && !this.event[key].length)) {
				if (key === 'clientEvent') {
					this.infobox.warning('Podanie klienta jest wymagane');
				}
				if (key === 'vehicles') {
					this.infobox.warning('Uzupełnij poprawnie pojazdy, a następnie kliknij przycisk "Dodaj"');
				}
				if (key === 'owner') {
					this.infobox.warning('Uzupełnij pole właściciela/opiekuna.');
				}
				this.errors[key] = true;
				hasErrors = true;
				continue;
			}

			this.errors[key] = false;
		}
		this.driverEventKind.forEach((type) => {
			this.event[type].forEach((obj) => {
				if (!obj.driver) {
					this.infobox.error('Uzupełnij kierowcę');
					this.loader.hide();
					hasErrors = true;
					return;
				}
			});
		});
		if (hasErrors) {
			this.loader.hide();
			return;
		}
		if (RentCategory.includes(this.event.category)) {
			if (!this.event.people) {
				this.infobox.error('Ilość osób nie jest podana');
				this.loader.hide();
				return;
			}
			if (!this.event.startPlace) {
				this.infobox.error('Miejsce podstawienia nie jest podane');
				this.loader.hide();
				return;
			}
			if (!this.event.text_program) {
				this.infobox.error('Program wyjazdu nie jest podany');
				this.loader.hide();
				return;
			}
			// check vehicle capacity
			const vehicle = this.findVehicleById(this.event.vehicles[0]?.id);
			if (this.event.people > vehicle.seats) {
				this.loader.hide();
				this.askQuestion('Zaplanowane jest więcej osób niż pomieści pojazd - czy zapisać?');
				return;
			}
		}
		this.save(false, mode);
	}

	sendData(obj) {
		this.event.clientEvent = {
			client: obj.id,
			event: this.event.id,
			isOrganization: obj.company,
		};
	}

	protected checkDriverDocument(delAction?: string): void {
		if (this.event.date_to < this.date.now().date) {
			return;
		}
		if (this.event.category === CategoryEvent.SERVICE || this.event.category === CategoryEvent.ENSILAGE) {
			return;
		}
		this.incorrectDrivers = [];
		this.documentDriverCorrect = true;
		this.event.is_virtual_driver = 0;
		this.virtualDrivers = [];
		this.driverEventKind.forEach((kind) => {
			this.event[kind].forEach((obj) => {
				this.checkLoadDriverDocument(obj);
			});
		});
		if (delAction != 'del') {
			this.showIncorrectDriver();
			return;
		}
	}

	protected checkLoadDriverDocument(driverEvent) {
		const checkStatus = ['REGULAR', 'JUMPER', 'B2B'];
		let documents = [];
		this.checkVirtualDriverExist(driverEvent.driver);
		if (this.virtualDrivers.length > 0) {
			this.event.is_virtual_driver = 1;
		}
		documents = this.driverDocuments.filter((objFind) => objFind.driver === driverEvent.driver);
		const vehicle = this.findVehicleById(this.event.vehicles[0]?.id);
		if (vehicle.type.id == 'bus' || vehicle.type.id == 'osobowy') {
			documents = documents.filter((objFind) => objFind.kind === 'driverLicense');
		}
		if (documents.length == 0 || !document) {
			const driver = this.drivers.find((objFind) => objFind.id == driverEvent.driver);
			if (!checkStatus.includes(driver.status)) {
				return;
			}
			driverEvent.driverName = driver ? driver.name : '?';
			this.incorrectDrivers.push(
				'<a target="_blank" href="/drivers/' + driverEvent.driver + '">' + driverEvent.driverName + '</a>',
			);
			this.documentDriverCorrect = false;
		} else {
			documents.every((element) => {
				if (this.date.addDays(-31, element.date) < driverEvent.date_to) {
					const driver = this.drivers.find((objFind) => objFind.id == driverEvent.driver);
					if (!checkStatus.includes(driver.status)) {
						return;
					}
					driverEvent.driverName = driver ? driver.name : '?';
					this.incorrectDrivers.push(
						'<a target="_blank" href="/drivers/' + element.driver + '">' + driverEvent.driverName + '</a>',
					);
					this.documentDriverCorrect = false;
					return false;
				}
				return true;
			});
		}
	}

	protected changeDriver(driver) {
		let driverSalaryDays = [];
		this.api.get(`/tourismEventDriverDays/?tourismEventDriver=${driver.tourismEventDriver}`, (result, error) => {
			driverSalaryDays = result.data;
			if (driver.driver && driver.driver !== this.focusedDriver && driverSalaryDays?.length !== 0) {
				this.question.ask(
					'Zmieniasz kierowcę, który ma uzupełnione stawki. Jeżeli zatwierdzisz zmianę jego dniówki zostaną wyzerowane. Czy jesteś pewn(y/a) zmiany?',
					'askQuestion',
				);
				const questionSubscription = this.question.status.subscribe((result) => {
					if (result.dialogId != 'askQuestion') {
						return;
					}
					questionSubscription.unsubscribe();
					if (!result.result) {
						driver.driver = this.focusedDriver;
						return;
					}
					this.api.command(
						'/tourismEventDriverDays/',
						{
							cmd: 'clearSalary',
							tourismEvent: driver,
						},
						(result, error) => {
							if (error) {
								return;
							}
						},
					);
				});
			}
		});
	}

	protected checkEditedDriverDocument(driverEvent): void {
		if (this.event.date_to < this.date.now().date) {
			return;
		}
		if (this.event.category === CategoryEvent.SERVICE || this.event.category === CategoryEvent.ENSILAGE) {
			return;
		}
		this.api.get('/driverDocuments/', (result, error) => {
			this.driverDocuments = result.data;
			this.incorrectDrivers = [];
			this.virtualDrivers = [];
			this.event.is_virtual_driver = 0;
			this.documentDriverCorrect = true;
			this.driverEventKind.forEach((kind) => {
				driverEvent[kind].forEach((obj) => {
					this.checkLoadDriverDocument(obj);
				});
			});
			if (this.incorrectDrivers.length != 0) {
				this.documentDriverCorrect = false;
				this.showIncorrectDriver();
				return;
			}
			return;
		});
	}

	protected checkVirtualDriverExist(driverId) {
		const driver = this.drivers.find((objFind) => driverId === objFind.id);
		if (driver.status === 'VIRTUAL') {
			this.virtualDrivers.push(driver);
		}
	}

	protected addDriverDocumentTask(eventId) {
		if (!this.event.id) {
			this.event.id = eventId;
		}
		const taskContent = '<p>Zweryfikuj dokumenty kierowców w wydarzeniu </p>';
		let addTask = true;
		this.api.get('/tasks/?objType=tourismEvent&status=1&objId=' + this.event.id, (result, error) => {
			result.data.forEach((obj) => {
				addTask = false;
				return false;
			});
			if (addTask) {
				this.task.add(
					'tourismEvent',
					this.event.id,
					['klLtTkZcGwRW5X4a5kFJs1kiTeJddUHN'],
					this.date.addDays(1),
					taskContent,
					() => {
						this.loader.hide();
					},
				);
			}
			return true;
		});
	}

	protected showIncorrectDriver(): boolean {
		if (!this.documentDriverCorrect) {
			this.infobox.error('Zweryfikuj dokumenty kierowcy:</br>' + this.incorrectDrivers);
			return false;
		}
		return true;
	}

	driverModalOpen(driver) {
		if (!this.lockEdit) {
			return;
		}
		this.driverSelected = driver;
	}

	driverSelectedClose() {
		this.driverSelected = null;
	}
	private patchTermTourismEvent(payload: TermTourismEvent): Promise<TermTourismEvent> {
		return new Promise((resolve, reject) => {
			this.bag.patch(`/transport/transport_term_tourism_event/${payload.id}/`, payload, (result, error) => {
				if (result) resolve(result);
				else reject(error);
			});
		});
	}

	save(force: boolean, mode: 'save' | 'copy') {
		this.loader.show();
		let data: any = {
			id: null,
			drivers_departure: null,
			drivers_program: null,
			drivers_return: null,
			addWithColision: null,
		};
		for (const key in this.event) {
			data[key] = this.event[key];
		}
		data.addWithColision = force ? 1 : 0;
		data = this.convertDataOnSave(data);

		if (mode === 'copy') {
			this.loader.hide();
			this.dialog
				.open(TourismEventsCopyConfirmDialogComponent)
				.afterClosed()
				.pipe(filter(Boolean))
				.subscribe(() => {
					this.api.post('/tourismEvents/', data, (result, error) => {
						this.afterSend(result, error);
						if (!error) {
							window.open(`${window.origin}/tourism-events/${result.data.id}`);
						}
					});
				});

			return;
		}

		if (this.editable) {
			this.api.put('/tourismEvents/' + this.event.id + '/', data, (result, error) => {
				this.bag.get(
					`/transport/transport_term_tourism_event/?event_id=${this.event.id}`,
					(bagResult, error) => {
						if (bagResult.results.length > 0 && !error) {
							const bagRequests = [];
							const vehicle = this.findVehicleById(this.event.vehicles[0]?.id);
							bagResult.results.forEach((bagEvent) => {
								const payload: TermTourismEvent = {
									id: bagEvent.id,
									eventId: bagEvent.eventId,
									kind: bagEvent.kind,
									maxSeat: vehicle.seats ? parseInt(vehicle.seats) + 2 : 0,
								};
								bagRequests.push(this.patchTermTourismEvent(payload));
							});

							Promise.all(bagRequests).then(() => {
								this.infobox.success('Pomyślnie zaktualizowano wydarzenia w BAG');
							});
						}
					},
				);

				this.afterSend(result, error);
			});
		} else {
			data.id = this.uuid.generate();
			this.api.post('/tourismEvents/', data, (result, error) => {
				this.afterSend(result, error, data.id);
			});
		}
	}

	backToCalendar() {
		if (!this.lockEdit) {
			this.api.del('/locks/tourismEvents/' + this.event.id, (result, error) => {});
		}
		this.router.navigate(['tourism-calendar']);
	}

	afterSend(result = null, error = null, eventId?) {
		this.loader.hide();
		if (error) {
			if (
				error.error.errorCode == 409 &&
				this.auth.permissionsByCode()[Permissions.VEHICLES_EVENTS_ADDITIONS_BESIDES_CONFLICTS]
			) {
				this.askQuestion(error.error.error + '. Czy mimo to zapisać?');
				return;
			}
			return;
		}
		if (!this.documentDriverCorrect) {
			this.addDriverDocumentTask(eventId);
		}
		if (this.editable) {
			this.api.del('/locks/tourismEvents/' + this.event.id, (result, error) => {});
			this.infobox.success('Zapisano');
			this.lockEdit = true;
			return;
		}
		const date2save = !this.event.date_from ? this.date.now().date : this.event.date_from.split('T')[0];
		this.lockEdit = true;
		this.router.navigate(['tourism-calendar', date2save]);
		this.setCalendarDate(date2save);
	}

	private setCalendarDate(date): void {
		const settings = {
			calendarDate: date,
		};
		localStorage.setItem('pageSettings-tourismCalendar', JSON.stringify(settings));
	}

	calculateDateAuto() {
		this.driverEventKind.forEach((type) => {
			this.event[type].forEach((driver) => {
				this.autoDate(type, driver, 'dateFromAuto', 'date_from');
				this.autoDate(type, driver, 'dateToAuto', 'date_to');
			});
		});
	}

	checkConfirmSalaryDrivers(driver) {
		if (!driver.date_from || !driver.date_to || !driver.driver) {
			return;
		}

		this.api.get(
			`/driverSalaryConfirmed/?driver=${driver.driver}&dateFrom=${driver.date_from}&dateTo=${driver.date_to}`,
			(result, error) => {
				if (error) {
					return;
				}
				this.driverSalaryConfirmed = result.data;
				if (this.driverSalaryConfirmed) {
					this.infobox.error('Ten kierowca ma zatwierdzone rozliczenie w danym okresie.');
					return;
				}
			},
		);
	}

	protected onFocusedDriver(driver) {
		this.focusedDriver = driver;
	}

	autoDate(type: string, driver, dateAuto: string, date: string) {
		const parms = this.event[type].filter((obj) => obj.driver == driver.driver);
		if (parms[0][dateAuto] != true) {
			return;
		}
		parms[0][date] = this.event[date];
		this.checkConfirmSalaryDrivers(driver);
	}

	calculateDateTo() {
		if (this.event.date_to) {
			return;
		}
		this.event.date_to = this.event.date_from;
	}

	calculateDatePrepare() {
		if (this.event.datePrepareAuto != true) {
			return;
		}
		const date = new Date(this.event.date_from);
		date.setHours(date.getHours() - 1);
		this.event.date_prepare = this.date.toUtcIso(date);
	}

	calculateDateDeadline() {
		if (this.event.dateDeadlineAuto != true) {
			return;
		}
		if (!this.event.date_from) {
			return;
		}
		if (!this.event.created) {
			this.event.created = this.date.now().date;
		}
		const diff = this.date.daysBetween(this.event.created, this.event.date_from);
		let delta = 0;
		if (diff < 1) {
			delta = 0;
		} else if (diff < 7) {
			delta = 1;
		} else if (diff < 30) {
			delta = 5;
		} else {
			delta = 14;
		}
		const date = new Date(this.event.created);
		date.setDate(date.getDate() + delta);
		this.event.date_deadline = this.date.toUtcIso(date);
	}

	driverInformed(type: string) {
		this.event[type] = !this.event[type];
		const data = {
			event: this.event.id,
			type: type,
			value: this.event[type],
		};
		this.api.post('/tourismEventsActions/', data, (result, error) => {
			if (error) {
				this.event[type] = !this.event[type];
				return;
			}
		});
	}

	startPlaceChanged() {
		if (this.event.endPlace && this.event.endPostCode) {
			return;
		}
		this.event.endPlace = this.event.startPlace;
		this.event.endPostCode = this.event.startPostCode;
	}

	reportErrorOpen(field: string, fieldName: string) {
		this.reportErrorField = field;
		this.reportErrorFieldName = fieldName;
		this.reportErrorComment = '';
		new Modal(document.getElementById('reportErrorDialog')).show();
		setTimeout(() => {
			document.getElementById('reportErrorComment').focus();
		}, 500);
	}

	reportErrorClose() {
		const modal = Modal.getInstance(document.getElementById('reportErrorDialog'));
		if (!modal) {
			return;
		}
		modal.hide();
	}

	reportErrorConfirm() {
		this.loader.show();
		let contents = '<p>Nieprawidłowe dane</p>';
		if (this.reportErrorComment) {
			contents += '<p>Komentarz: ' + this.reportErrorComment + '</p>';
		}
		contents += '<p>W polu: ' + this.reportErrorFieldName + '</p>';
		contents += 'Błedna wartość: ' + this.event[this.reportErrorField];
		this.reportErrorClose();
		this.task.add('tourismEvent', this.event.id, this.event.owner, this.date.addDays(1), contents, () => {
			this.loader.hide();
		});
	}

	linkOpen() {
		this.linkComponent.linkOpen();
	}

	seasonOpen() {
		this.seasonComponent.seasonOpen();
	}

	protected convertDataOnSave(data) {
		return data;
	}

	private askQuestion(question: string): void {
		this.question.ask(question, 'askQuestion');
		const questionSubscription = this.question.status.subscribe((result) => {
			if (result.dialogId != 'askQuestion') {
				return;
			}
			questionSubscription.unsubscribe();
			if (!result.result) {
				return;
			}
			this.save(true, 'save');
		});
	}

	driverAddRow(type: string): void {
		this.event[type].push({
			driver: null,
			date_from: this.event.date_from,
			date_to: this.event.date_to,
			dateFromAuto: true,
			dateToAuto: true,
			tourismEventDriver: null,
		});
	}

	addDriverEvent(kind: string, typeDriver: string) {
		this.DriversEventAddComponent.openModal(kind, typeDriver);
	}

	deleteDriver(type: string, driver) {
		this.question.ask('Czy na pewno usunąć?', 'deleteAsk');
		const questionSubscription = this.question.status.subscribe((result) => {
			if (result.dialogId != 'deleteAsk') {
				return;
			}
			questionSubscription.unsubscribe();
			if (!result.result) {
				return;
			}
			this.event[type] = this.event[type].filter((obj) => obj.driver != driver.driver);
			this.checkDriverDocument('del');
		});
	}

	findVehicleById(id: number) {
		return this.vehicles.find((obj) => obj.id === id);
	}

	protected readonly RentCategory = RentCategory;
}
